import { Trans } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View, ViewProps } from 'react-native'
import { Color, Radius, Spacing, Text } from 'zens-storybook'
import { heatmapColor } from '@dms/helper'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    padding: Spacing.S,
    borderRadius: Radius.M,
    borderColor: Color.calmGrey,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    color: Color.calmGrey,
  },
  heatmap: {
    alignItems: 'flex-start',
    marginLeft: Spacing.L,
  },
  bars: {
    flexDirection: 'row',
    borderRadius: Radius.XS,
    overflow: 'hidden',
  },
  bar: {
    height: 9,
    width: 30,
  },
  labels: {
    flexDirection: 'row',
    marginLeft: -15,
  },
  label: {
    width: 30,
    alignItems: 'center',
  },
  labelText: {
    textAlign: 'center',
    lineHeight: 12,
    marginTop: Spacing.XXS,
  },
  other: {
    alignItems: 'center',
    marginLeft: Spacing.M,
  },
  noSensor: {
    backgroundColor: Color.calmGrey,
  },
  selected: {
    borderColor: Color.premiumBlack,
    borderWidth: 1,
  },
  notSelected: {
    opacity: 0.2,
  },
})

interface Props extends ViewProps {
  selected?: number
  onSelect?: (index: number) => void
}

const InsightsLegendHeatmap = (props: Props) => {
  const { selected, onSelect, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.title} numberOfLines={1}>
        <Trans>Occupancy</Trans>
      </Text>
      <View style={styles.heatmap}>
        <View style={styles.bars}>
          {new Array(10).fill('').map((_, index) => {
            const style = {
              backgroundColor: heatmapColor(index * 10),
            }
            return (
              <TouchableOpacity
                key={`bar-${index}`}
                style={[
                  styles.bar,
                  style,
                  selected === index ? styles.selected : selected !== undefined ? styles.notSelected : null,
                ]}
                onPress={() => onSelect?.(index)}
                testID="InsightsLegendHeatmap.Bar"
              />
            )
          })}
        </View>
        <View style={styles.labels}>
          {new Array(10).fill('').map((_, index) => (
            <View style={styles.label} key={`label-${index}`}>
              <Text style={styles.labelText} numberOfLines={1} level={7}>
                {index === 0 || (index + 1) % 2 === 0 ? `${index * 10}%` : ' '}
              </Text>
            </View>
          ))}
          <View style={styles.label}>
            <Text style={styles.labelText} numberOfLines={1} level={7}>
              100%
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.other}>
        <TouchableOpacity
          style={[
            styles.bars,
            styles.bar,
            styles.bar,
            styles.noSensor,
            selected === undefined ? null : isNaN(selected) ? styles.selected : styles.notSelected,
          ]}
          onPress={() => onSelect?.(NaN)}
          testID="InsightsLegendHeatmap.NoSensor"
        />
        <Text numberOfLines={1} level={7}>
          <Trans>Unknown</Trans>
        </Text>
      </View>
    </View>
  )
}

export default InsightsLegendHeatmap
